import React from "react";
import "./CreativeDesignSection2.css";
import creativeImage from "../../../assets/creativeImage.png";
import { useTranslation } from "react-i18next";

const CreativeDesignSection2 = () => {
  const { t } = useTranslation("global");

  return (
    <section className="creative-ideas" aria-label="Creative Design Philosophy">
      {/* Left Side - Image */}
      <div className="creative-image">
        <img
          src={creativeImage || "/placeholder.svg"}
          alt={t("creativeDesignSection2.imageAlt")}
          loading="lazy"
          width="500"
          height="400"
          title="Creative Design Process"
        />
      </div>

      {/* Right Side - Text */}
      <div className="creative-text">
        <p className="subheading">{t("creativeDesignSection2.subheading")}</p>
        <h2 className="section-heading">
          {t("creativeDesignSection2.heading1")}{" "}
          <span className="highlight">
            {t("creativeDesignSection2.headingHighlight")}
          </span>{" "}
          {/* Use responsive line break */}
          <span className="d-none d-md-inline">
            <br />
          </span>
          {t("creativeDesignSection2.heading2")}
        </h2>
        <p className="small-text">{t("creativeDesignSection2.smallText")}</p>
        <p className="description-creativesection2">
          {t("creativeDesignSection2.description")}
        </p>
      </div>
    </section>
  );
};

export default CreativeDesignSection2;
